import { render, staticRenderFns } from "./itemRows.vue?vue&type=template&id=877927d8&scoped=true&"
import script from "./itemRows.vue?vue&type=script&lang=js&"
export * from "./itemRows.vue?vue&type=script&lang=js&"
import style0 from "./itemRows.vue?vue&type=style&index=0&id=877927d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877927d8",
  null
  
)

export default component.exports